export const id = (state: any) => state.category.id;
